import { getBackEndBaseUrl } from 'src/utils/domain-utils';
import { ApiConfiguration } from './types';
import AxiosClient from './axios_client';
import { getCareflowToken, getTenantCodeFromCareflowToken } from '../authentication/util/token';

const apiConfig = new ApiConfiguration();

apiConfig.baseUrl = getBackEndBaseUrl() ?? '';
apiConfig.getAccessToken = getCareflowToken;
apiConfig.getHeaderTenantIdCode = getTenantCodeFromCareflowToken;

export const apiClient = new AxiosClient(apiConfig);